<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogTel',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-member-tel-dialog'" :title="state.dialog.title"
    width="400px" :ok-text="state.dialog.submitTxt" @ok="onSubmit" @cancel="closeDialog" :closable="false"
    :maskClosable="false">
    <a-form ref="formRef" :model="state.ruleForm" :rules="state.rules" :label-col="{ style: 'width: 90px' }"
      :wrapper-col="{ style: 'flex: 1' }">
      <a-form-item label="手机号" name="tel">
        <a-input v-model:value="state.ruleForm.tel" placeholder="请输入手机号" :maxlength="11" />
      </a-form-item>
    </a-form>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogTel">
import { reactive, ref } from 'vue'
import { cloneDeep } from 'lodash-es'

const emit = defineEmits(['updateUserTel'])

const formRef = ref()

const state = reactive({
  ruleForm: {
    userId: '',
    username: '',
    tel: '',
    name: '',
    gender: '',
    freeze: '',
    type: '',
    microName: '',
    microId: '',
    documentCode: '',
    documentType: '1',
    headUrl: ''
  },
  rules: {
    tel: [
      { required: true, message: '请输入手机号', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
    ]
  },
  dialog: {
    visible: false,
    title: '修改手机号',
    submitTxt: '修改'
  }
})

const openDialogTel = (row: any) => {
  state.ruleForm = cloneDeep(row)
  state.dialog.visible = true
}

const closeDialogTel = () => {
  state.dialog.visible = false
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(() => {
      emit('updateUserTel', cloneDeep(state.ruleForm))
    })
    .catch(() => { })
}

defineExpose({
  openDialogTel,
  closeDialogTel
})
</script>
